export default __webpack_public_path__ + "static/B0288-b79380ea47c56ed0c47f820cf9ddc076.png";